import * as bootstrap from 'bootstrap';
import AscendingNumber from "../components/ascending-number/ascending-number.js";

console.log('Soundfangled - here we go');
if (document.querySelector(".ascending__number")) {
  new AscendingNumber();
}

import PackageForm from "../components/packages-detail-content/packages-detail-content.js";
if (document.getElementById("#package-detail-form")) {
  new PackageForm();
}

import Tooltips from "../components/tooltips/tooltips.js";
if (document.querySelectorAll('[data-bs-toggle="tooltip"]')) {
  new Tooltips();
}